module.exports = __webpack_public_path__ + "static/media/customs_88295.c3a48728.png";